/* AXON V12: pure option and media resolution. No account or payment data. */
const AXONVariantCore = (() => {
  const same = (a,b) => String(a) === String(b);
  const exact = (variant, values) => variant && variant.options.every((v,i) => same(v,values[i]));
  function resolve(variants, wanted, changedIndex = -1) {
    const found = variants.find(v => exact(v,wanted));
    if (found) return found; // Preserve an explicitly selected sold-out combination.
    const pool = changedIndex >= 0 ? variants.filter(v => same(v.options[changedIndex],wanted[changedIndex])) : variants;
    const candidates = pool.length ? pool : variants;
    return candidates.slice().sort((a,b) => {
      const score = v => v.options.reduce((n,x,i) => n + (same(x,wanted[i]) ? (i === changedIndex ? 100 : 10) : 0),0) + (v.available ? 1 : 0);
      return score(b)-score(a);
    })[0] || null;
  }
  function availability(variants, selected, index, value) {
    const matches = variants.filter(v => v.options.every((x,i) => i === index || same(x,selected[i])) && same(v.options[index],value));
    return {exists:matches.length>0,available:matches.some(v=>v.available)};
  }
  function colorIndex(options) { return options.findIndex(o=>/colou?r|shade/i.test(o.name)); }
  function mediaColor(alt) {
    const text=String(alt||'');
    const match=text.match(/\[\s*color\s*:\s*([^\]]+)\]/i) || text.match(/(?:^|[|;])\s*color\s*:\s*([^|;]+)(?:[|;]|$)/i);
    return match ? match[1].trim().toLowerCase() : null;
  }
  function mediaForColor(data, color, preferredId) {
    const media=data.media||[];
    const index=colorIndex(data.options||[]);
    if(index<0 || !color) return {ids:media.map(m=>String(m.id)),preferred:preferredId};
    const anchors=new Map();
    for(const link of data.variantMedia||[]) {
      const variant=(data.variants||[]).find(v=>same(v.id,link.id));
      if(!variant || !link.mediaId) continue;
      const key=String(link.mediaId);
      if(!anchors.has(key)) anchors.set(key,new Set());
      anchors.get(key).add(String(variant.options[index]).toLowerCase());
    }
    let active=new Set();
    const requested=String(color).toLowerCase();
    const ids=[];
    for(const m of media) {
      const tag=mediaColor(m.alt);
      const anchor=anchors.get(String(m.id));
      if(tag) active=new Set([tag]);
      else if(anchor) active=new Set(anchor);
      // Images before the first anchor are shared. Following images belong to
      // the last assigned color until the next anchor or explicit color tag.
      if(!active.size || active.has(requested)) ids.push(String(m.id));
    }
    if(!ids.length) return {ids:media.map(m=>String(m.id)),preferred:preferredId};
    const preferred=preferredId && ids.includes(String(preferredId)) ? preferredId : ids[0];
    return {ids,preferred};
  }
  function money(cents,format,currency='USD') {
    const n=Number(cents)/100;
    if(!Number.isFinite(n)) return '';
    const template=String(format||'').replace(/<[^>]*>/g,'');
    if(!/\{\{\s*\w+\s*\}\}/.test(template)) {
      try {return new Intl.NumberFormat('en-US',{style:'currency',currency}).format(n);}catch(e){return '$'+n.toFixed(2);}
    }
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g,(_,token)=>{
      const integer=token.includes('no_decimals');
      let decimal='.',group=',';
      if(token.includes('comma_separator')){decimal=',';group='.';}
      else if(token.includes('apostrophe_separator')){group="'";}
      else if(token.includes('space_separator')){group=' ';}
      const fixed=n.toFixed(integer?0:2).split('.');
      return fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g,group)+(fixed[1]?decimal+fixed[1]:'');
    });
  }
  return {resolve,availability,colorIndex,mediaColor,mediaForColor,money};
})();
if(typeof module!=='undefined' && module.exports) module.exports=AXONVariantCore;
